import React from 'react';
import { ts } from 'src/utils/translate';
import { IMAGE_HOST } from 'src/utils/constants';
import { ProjectQuoteUserProperties } from 'src/model/api/project.model';

export const IDetails = React.memo(function WrappedIDetails(props: any) {
  const {cols, row, className, colSpan, quoteUserProperties } = props;

  const getColName = React.useCallback((key: any) => {
    const col = cols.find((col: any) => col.data === key);
    if (col) {
      return col.title;
    } else {
      return "";
    }
  }, []);

  const hiddenColumns = calcHiddenColumns(quoteUserProperties);
  const detailProps = React.useMemo(() => {
    return [
      {
        propKey: "manufacturer_name",
        propName: getColName("manufacturer_name"),
      },
      { propKey: "design", propName: ts("q_design", "Design") },
      { propKey: "color_name", propName: ts("color", "Color") },
      { propKey: "article_number", propName: getColName("article_number") },
      {
        propKey: "custom_description",
        propName: getColName("custom_description"),
      },
    ]
      .map((prop) => {
        if(prop.propKey === "design") {
          if(row.manufacturer_name && row.manufacturer_name.toLowerCase().match(/^gira/) && row.color_name) {
            const colorNameSplit = row.color_name.split(' ');
            if (colorNameSplit.length) {
                const designName = colorNameSplit[0];
                return { ...prop, propVal: designName || "" };
            }
          } else if(row.manufacturer_name && row.manufacturer_name.toLowerCase().match(/^(schneider)|(legrand)/)) {
            const manuNameSplit = row.manufacturer_name.split(' ');
            if (manuNameSplit.length) {
              const manuName = manuNameSplit[0];
                const designName = row.manufacturer_name.replace(manuName, '').trim();
                return { ...prop, propVal: designName || "" };
            }
          }
          return { ...prop, propVal: row[prop.propKey] || "" };
        } else if(prop.propKey === "color_name") {
          if(row.manufacturer_name && row.manufacturer_name.toLowerCase().match(/^gira/) && row.color_name) {
            const colorNameSplit = row.color_name.split(' ');
            if (colorNameSplit.length) {
                const designName = colorNameSplit[0];
                let colorName = row.color_name.replace(designName, '').trim();
                colorName = colorName.charAt(0).toUpperCase() + colorName.substring(1).toLowerCase();
                return { ...prop, propVal: colorName || "" };
            }
          }
          return { ...prop, propVal: row[prop.propKey] || "" };
        } else if (prop.propKey === "manufacturer_name") {
          if (row.manufacturer_name && row.manufacturer_name.toLowerCase().match(/^(schneider)|(legrand)/)) {
            const manuNameSplit = row.manufacturer_name.split(' ');
            if (manuNameSplit.length) {
                const manuName = manuNameSplit[0];
                return { ...prop, propVal: manuName || "" };
            }
          } 
          return { ...prop, propVal: row[prop.propKey] || "" };
        } else {
          return { ...prop, propVal: row[prop.propKey] || "" };
        }
      })
    // TODO: resolvethis
      .filter(
        (prop) =>
            prop.propVal && hiddenColumns.indexOf(prop.propKey) === -1
      );
  }, [getColName, row, quoteUserProperties]);

  const picExists = !!row.image_url;
  const detailExists = detailProps.length || picExists;

  const isProtocolInUrl = (icon: any) => {
    return typeof icon === "string" && icon.indexOf("http") === 0;
  };

  return detailExists ? (
    <td colSpan={2}>
      <table width="100%">
        <tbody>
          <tr>
            <td style={{ width: 130, display: row.image_url ? "" : "none" }}>
              <a
                target="_blank"
                href={
                  isProtocolInUrl(row.image_url)
                    ? row.image_url
                    : `${IMAGE_HOST}${row.image_url}`
                }
              >
                <div
                  className="quote-child-image"
                  style={{
                    backgroundImage: `url('${
                      isProtocolInUrl(row.image_url)
                        ? row.image_url
                        : `${IMAGE_HOST}${row.image_url}`
                    }')`,
                  }}
                ></div>
              </a>
            </td>
            <td style={{ display: detailProps.length ? "" : "none" }}>
              <ul style={{ marginBottom: 0 }}>
                {detailProps.map((prop) => (
                  <li key={prop.propKey}>
                    <span style={{ fontWeight: 800 }}>{prop.propName}:</span>{" "}
                    <span>{prop.propVal}</span>
                  </li>
                ))}
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  ) : null;
});

function calcHiddenColumns(quoteUserProperties: ProjectQuoteUserProperties): string[] {
  const hiddenColumns = [];
  if (quoteUserProperties.include_article_number === 0) {
    hiddenColumns.push("article_number")
  }
  if (quoteUserProperties.include_comments === 0) {
    hiddenColumns.push("custom_description")
  }
  if (quoteUserProperties.include_prices === 0) {
    hiddenColumns.push("prices")
  }
  if (quoteUserProperties.include_back_boxes === 0) {
    hiddenColumns.push("include_back_boxes")
  }
  return hiddenColumns;
}
